import { AnimatePresence, motion } from 'framer-motion'
import { Icon } from './Brand'
import { tintMap } from '../data'
import { relTime } from '../lib/time'

export default function NotificationsPage({ items = [], onRead = () => {}, onReadAll = () => {} }) {
  const unread = items.filter((n) => !n.read).length

  return (
    <>
      <motion.div
        className="page-head"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      >
        <div>
          <div className="eyebrow">Activity</div>
          <h1>Notifications</h1>
          <p className="sub">{unread} unread · {items.length} total</p>
        </div>
        {unread > 0 && (
          <button className="chat-suggest" onClick={onReadAll}>Mark all read</button>
        )}
      </motion.div>

      {items.length === 0 ? (
        <div className="chat-empty">
          <div className="cs-ic"><Icon name="notifications_none" /></div>
          <p>No activity yet — ask a question in Chat and your agents' answers will show up here.</p>
        </div>
      ) : (
        <>
          <div className="section-label">Recent</div>
          <div className="notif-list">
            <AnimatePresence initial={false}>
              {items.map((n) => {
                const tint = tintMap[n.tint] || tintMap.lav
                return (
                  <motion.button
                    type="button"
                    key={n.id}
                    className={`notif ${n.read ? 'read' : 'unread'}`}
                    onClick={() => onRead(n.id)}
                    layout
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                  >
                    <div className="notif-ic" style={{ background: tint.bg }}>
                      <Icon name={n.icon} style={{ color: tint.fg }} />
                    </div>
                    <div className="notif-body">
                      <div className="notif-title">{n.title}</div>
                      <div className="notif-text">{n.text}</div>
                    </div>
                    <div className="notif-when">{relTime(n.when)}</div>
                    {!n.read && <span className="notif-dot" />}
                  </motion.button>
                )
              })}
            </AnimatePresence>
          </div>
        </>
      )}
    </>
  )
}
